import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

export default function DailyQuote() {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    api
      .get("/quote/daily")
      .then((res) => setQuote(res.data.quote || ""))
      .catch(() => {});
  }, []);

  if (!quote) return null;

  return (
    <section data-testid="daily-quote" className="px-6 py-14 md:px-16 lg:px-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        className="mx-auto max-w-[1600px] border-y border-[#FFD700]/20 bg-[#0A0A0A] px-6 py-12 text-center"
      >
        <p className="mb-5 flex items-center justify-center gap-3 font-mono text-[10px] uppercase tracking-[0.35em] text-[#666666]">
          <span className="inline-block h-px w-8 bg-[#FFD700]/40" />
          இன்றைய Money Vibe
          <span className="inline-block h-px w-8 bg-[#FFD700]/40" />
        </p>
        <p
          data-testid="daily-quote-text"
          className="font-heading text-2xl font-bold leading-relaxed text-[#FFD700] md:text-4xl"
        >
          “{quote}”
        </p>
      </motion.div>
    </section>
  );
}
